<script>
export default {
  data() {
    return {
      // search: "",
      editedItem: {},
      editedIndex: 0,
      // pagination: {
      //   descending: true,
      //   //page: 0,
      //   rowsPerPage: 10 // -1 for All
      //   //sortBy: "firstName"
      //   //totalItems: number
      // },
      actions: {
        text: "Actions",
        value: "name",
        align: "center",
        sortable: false
      }
    };
  },
  methods: {
    getHeaders(item) {
      let cols = Object.getOwnPropertyNames(item)
        .filter(x => !x.startsWith("_"))
        .map(x => {
          return {
            text: x,
            value: x,
            sortable: true,
            align: "center"
          };
        });
      //cols.push(this.actions);
      return cols;
    },
    isDateColumn(name) {
      return name ? name.toLowerCase().includes("date") : false;
    },
    currencyFormatter(val) {
      let rounded = Number(Math.round(val.value + "e" + 2) + "e-" + 2).toFixed(
        2
      );
      return `$${rounded}`;
    },
    formatNumber(number) {
      return Math.floor(number)
        .toString()
        .replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1,");
    },
    dateFormatter(number) {
      let date = new Date(number.value);
      return new Intl.DateTimeFormat("en-AU").format(date);
    }
  }
};
</script>
